
import React, { useState, useRef, useEffect } from 'react';
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';
import { Avatar, Stack } from '@chakra-ui/react';
import { Mail, MessageCircle, Handshake, Newspaper, Search } from 'lucide-react';
import WhatsApp from '../../../utils/communications/whatsapp/WhatsApp.js';
import Chat from '../../../utils/communications/chat/Chat.js';
import Email from '../../../utils/communications/email/Email.js';
import Notes from '../../../utils/notes/Notes.js';
import {getInjuryListById} from '../../../redux/api/healthSaftyApi/HealthSaftyInjury.js';
import { useLocation } from 'react-router-dom';
import Task from '../../crm/lead/Task/Task.js';
import Attachment from '../../inspection/Attachments.js';


export default function InjuryDetailView() {

    const location = useLocation();
    const id = location.state?.ROWID || "";
    const [item, setitem] = useState(null);
    useEffect(() => {
       console.log(location)
        console.log({ id })
        

        getInjuryListById(id).then((response) => {
            if (response.data.success ) {
                setitem(response.data.injury[0]);
            }
        }).catch((error) => {
            console.log({ error });
        });
    }, [id]);

    useEffect(() => {
        console.log({ item })
    }, [item])

    //for adding scrollbar in tablist
    const tabListRef = useRef(null);
    const [touchStartX, setTouchStartX] = useState(0);
    const [touchEndX, setTouchEndX] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => setIsOpen(prevState => !prevState);

    const handleTouchStart = (e) => {
        setTouchStartX(e.touches[0].itemX);
    };

    const handleTouchMove = (e) => {
        setTouchEndX(e.touches[0].itemX);
    };

    const handleTouchEnd = () => {
        if (tabListRef.current) {
            const distance = touchStartX - touchEndX;

            if (distance > 50) {
                // Swipe left to scroll right
                tabListRef.current.scrollBy({ left: 100, behavior: 'smooth' });
            } else if (distance < -50) {
                // Swipe right to scroll left
                tabListRef.current.scrollBy({ left: -100, behavior: 'smooth' });
            }
        }
    };
    return (
        <div className='custom-scroll' style={{ minHeight: '88vh' }} >
            <Tabs variant='enclosed'>
                <TabList ref={tabListRef} className="custom-tablist" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
                    <Tab>Overview</Tab>
                    <Tab>Notes</Tab>
                    <Tab >Attachments</Tab>
                    <Tab>Comms</Tab>
                    <Tab>Task</Tab>
                </TabList>
                <TabPanels >
                    {/* Overview panel */}
                    <TabPanel className='customScroll'>
                        <div>
                            {/* Profile div  */}
                            <div className='wrapper card card-detail mt-4 itemDetail mobile-margin'>
                                <div className='d-flex ' style={{ marginLeft: '14px' }} >
                                    <div className='col-lg-2 col-md-12 col-3 align-items-center justify-content-center mt-3'>
                                        <Stack direction='row' >
                                            <Avatar size='xl' name='Prosper Otemuyiwa' src='https://i.imgur.com/Lt5Cjb0.jpeg' boxSize={{ base: '80px', xl: '100px' }} />
                                        </Stack>
                                    </div>
                                    <div className='col-lg-6 col-md-12 col-8 mt-4 ms-3'>
                                        <h4 style={{ color: "#023233" }}>{item?.employeeName || 'NA'}</h4>
                                        <p>Injury</p>
                                        {/* for mobile icons starts */}
                                        <div className="div d-lg-none  d-md-none">
                                            <div className="div d-flex ">
                                                <Mail color='#ff176b' strokeWidth="1" className='ms-1 itemphoneIcon' />
                                                <MessageCircle color='#ff176b' strokeWidth="1" className='ms-2 itemphoneIcon' />
                                                <Handshake color='#ff176b' strokeWidth="1" className='ms-2 itemphoneIcon' />
                                                <Newspaper color='#ff176b' strokeWidth="1" className='ms-2 itemphoneIcon' />
                                            </div>
                                        </div>
                                        {/* for mobile icons ends */}
                                    </div>
                                    <div className='col-lg-4 col-md-12 mt-3'>
                                        {/* for desktop icons start */}
                                        <div className='d-none d-sm-flex gap-3 mt-3'>
                                            <Mail color='#ff176b' strokeWidth="1" />
                                            <MessageCircle color='#ff176b' strokeWidth="1" />
                                            <Handshake color='#ff176b' strokeWidth="1" />
                                            <Newspaper color='#ff176b' strokeWidth="1" />
                                        </div>
                                        {/* for desktop icons end */}
                                    </div>
                                </div>
                            </div>
                            {/* Profile div  end */}
                            {/* Below content  */}
                            <h6 style={{ color: "#767272", marginLeft: "10px", marginTop:"10px" }}>Injury Information</h6>
                            <div class="wrapper mt-1">
                                <div class="row g-3">
                                    <div class="col-lg-6 col-md-12 d-flex align-items-stretch">
                                        <div class="card card-detail p-0 w-100">
                                            <div class="card-body py-0 pe-0">
                                                <div class="table-responsive table-div1">
                                                    <table class="table table-space ">
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Employee Name</th>
                                                            <td className='font-color'>{item?.employeeName || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Employee ID</th>
                                                            <td className='font-color'>{item?.employeeID || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Date Of Incident</th>
                                                            <td className='font-color'>{item?.dateOfIncident || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Time Of Incident</th>
                                                            <td className='font-color'>{item?.timeOfIncident || 'NA'}</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-12  d-flex align-items-stretch">
                                        <div class="card card-detail p-0 w-100">
                                            <div class="card-body py-0 pe-0">
                                                <div class="table-responsive">
                                                    <table class="table table-space">
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Job Title</th>
                                                            <td className='font-color'>{item?.jobTitle || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Department</th>
                                                            <td className='font-color'>	{item?.department || 'NA'}</td>
                                                        </tr>
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Supervisor</th>
                                                            <td className='font-color'>{item?.supervisor || 'NA'}</td>
                                                        </tr>

                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h6 style={{ color: "#767272", marginLeft: "10px" , marginTop: "10px"}}>Injury Details</h6>
                                <div className='row '>
                                    <div class="col-lg-6 col-md-12 d-flex align-items-stretch">
                                        <div class="card card-detail p-0 w-100">
                                            <div class="card-body py-0 pe-0">
                                                <div class="table-responsive">
                                                    <table class="table item-table-space " >
                                                        <tbody>
                                                            <tr className='tr-border'>
                                                                <th className='font-weight table-space'>Type Of Injury</th>
                                                                <td className='font-color'>{item?.typeOfInjury || 'NA'}</td>
                                                            </tr>

                                                            <tr className='tr-border'>
                                                                <th className='font-weight table-space'>Body Part Injured</th>
                                                                <td className='font-color'>{item?.bodyPartInjured || 'NA'}</td>
                                                            </tr>
                                                            <tr className='tr-border'>
                                                                <th className='font-weight table-space'>Nature Of Injury</th>
                                                                <td className='font-color'>{item?.natureOfInjury || 'NA'}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-12 d-flex align-items-stretch">
                                        <div class="card card-detail p-0 w-100">
                                            <div class="card-body py-0 pe-0">
                                                <div class="table-responsive">
                                                    <table class="table item-table-space " >
                                                        <tbody>
                                                            <tr className='tr-border'>
                                                                <th className='font-weight table-space'>Severity Of Injury</th>
                                                                <td className='font-color'>{item?.severityOfInjury || 'NA'}</td>
                                                            </tr>
                                                            <tr className='tr-border'>
                                                                <th className='font-weight table-space'>Witness Name</th>
                                                                <td className='font-color'>{item?.witnessName || 'NA'}</td>
                                                            </tr>

                                                            <tr className='tr-border'>
                                                                <th className='font-weight table-space'>Contact Information</th>
                                                                <td className='font-color'>{item?.contactInformation || 'NA'}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h6 style={{ color: "#767272", marginLeft: "10px", marginTop: "10px" }}>Immediate Action Taken</h6>
                                <div className='row g-3'>
                                    <div class="col-lg-6 col-md-12 d-flex   align-items-stretch">
                                        <div class="card card-detail p-0  w-100">
                                            <div class="card-body py-0 pe-0">
                                                <div class="table-responsive">
                                                    <table class="table table-space ">
                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>First Aid Provided</th>
                                                            <td className='font-color'>{item?.firstAidProvided || 'NA'}</td>
                                                        </tr>

                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Medical Attention Requried</th>
                                                            <td className='font-color'>{item?.medicalAttentionRequired || 'NA'}</td>
                                                        </tr>

                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>Emergency Services Called</th>
                                                            <td className='font-color'>{item?.emergencyServicesCalled || 'NA'}</td>
                                                        </tr>

                                                        <tr className='tr-border'>
                                                            <th className='font-weight table-space'>If yes then which services</th>
                                                            <td className='font-color'>{item?.ifYesThenWhichServices || 'NA'}</td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h6 style={{ color: "#767272", marginLeft: "10px", marginTop: "10px" }}>Description</h6>
                                <div className='row g-3'>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="card card-detail p-4">
                                            <div className="card-body py-0 pe-0">
                                                <div className='tr-border'>{item?.description || 'NA'}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h6 style={{ color: "#767272", marginLeft: "10px", marginTop: "10px" }}>Additional Notes</h6>
                                <div className='row g-3'>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="card card-detail p-4">
                                            <div className="card-body py-0 pe-0">
                                                <div className='tr-border'>{item?.additionalNotes || 'NA'}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    {/* Overview panel ends*/}
                    {/* notes panel  */}
                    <TabPanel className='pt-0'>
                        <Notes module={"injury"} id={id}  />
                    </TabPanel>
                    {/* notes panel ends */}
                    <TabPanel>
                       <Attachment />
                    </TabPanel>
                    {/* tab panel for comms */}
                    <TabPanel>
                        <div className='w-100 d-flex justify-content-between align-items-center'>
                            <section>
                                <div className=' popup-search d-flex align-items-center my-4 bg-white mobile-margin'>
                                    <Search size="18px" /> <input type='search' className='ms-2' style={{ outline: "none", border: "none" }} placeholder='Search' />
                                </div>
                            </section>
                            <section>
                            </section>
                        </div>
                        {/* tabs for subnav */}
                        <Tabs size='sm' variant='enclosed'>
                            <TabList>
                                <Tab>WhatsApp</Tab>
                                <Tab>SMS</Tab>
                                <Tab>Email</Tab>
                            </TabList>
                            <TabPanels>
                                <TabPanel className='custom-scroll '>
                                    <WhatsApp />
                                </TabPanel>
                                <TabPanel className='custom-scroll '>
                                    <Chat />
                                </TabPanel>
                                <TabPanel className='custom-scroll '>
                                    <Email />
                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                        {/* tabs for subnav ends */}
                    </TabPanel>
                    {/* tab panel for comms ends*/}
                    <TabPanel>
                      <Task />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </div>
    )
}